import {
  Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Tab, Tabs,
} from '@heroui/react';
import { Upload } from 'lucide-react';
import React, { FC } from 'react';

import { useGetAdAssets } from '../../../../queries';
/* Ta sama biblioteka i ta sama ścieżka wgrywania co w generatorze reklam: pliki lądują
   w tym samym katalogu Bytescale i w tym samym rejestrze, więc grafika wgrana do reklamy
   jest od razu dostępna w wiadomości i odwrotnie. */
import { useAssetUpload } from '../../../AdsGenerator/hooks';
import { StockPhotoPanel } from './StockPhotoPanel';

interface ImageSourceModalProps {
  onPick: (url: string) => void;
  onClose: () => void;
}

export const ImageSourceModal: FC<ImageSourceModalProps> = ({ onPick, onClose }) => {
  const { data: assets = [] } = useGetAdAssets();
  const { inputRef, accept, isUploading, openPicker, handleFiles } = useAssetUpload();

  return (
    <Modal isOpen size="lg" radius="sm" onClose={onClose}>
      <ModalContent>
        <ModalHeader>Grafika w wiadomości</ModalHeader>
        <ModalBody>
          <Tabs size="sm" aria-label="Źródło grafiki">
            <Tab key="library" title="Biblioteka">
              <input
                ref={inputRef}
                type="file"
                accept={accept}
                hidden
                onChange={async (event) => {
                  const uploaded = await handleFiles(event.target.files);
                  if (uploaded[0]) onPick(uploaded[0].url);
                }}
              />
              <Button
                size="sm"
                radius="sm"
                variant="flat"
                className="self-start"
                startContent={<Upload size={16} />}
                isLoading={isUploading}
                onPress={openPicker}
              >
                Wgraj z dysku
              </Button>

              {assets.length === 0 ? (
                <p className="py-6 text-center text-sm text-gray-500">
                  Biblioteka jest pusta. Wgraj pierwszy plik z dysku albo poszukaj w banku zdjęć.
                </p>
              ) : (
                <div className="grid max-h-80 grid-cols-4 gap-3 overflow-auto py-2">
                  {assets.map((asset) => (
                    <button
                      key={asset.id}
                      type="button"
                      title={asset.name}
                      className="overflow-hidden rounded-lg border border-gray-200 bg-gray-50 p-1 hover:border-gray-400"
                      onClick={() => onPick(asset.url)}
                    >
                      <img src={asset.url} alt="" crossOrigin="anonymous" className="h-20 w-full object-contain" />
                    </button>
                  ))}
                </div>
              )}
            </Tab>

            <Tab key="stock" title="Bank zdjęć">
              <StockPhotoPanel onPicked={onPick} />
            </Tab>
          </Tabs>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" radius="sm" variant="light" onPress={onClose}>
            Anuluj
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
